module.exports = __webpack_public_path__ + "img/妖魔岭.a30dabb1.png";